import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';


const HomeNav = () => {
    const expand = 'lg'
    return (
        <>

            <Navbar expand={expand} className="navBar sticky-top">
                <Container >
                    <Navbar.Brand href="/" className="brandName">Sodiq Azeez</Navbar.Brand>
                    <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="end"
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                                Sodiq
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-end flex-grow-1 navLinkContainer">
                                <Nav.Link href="/">Home</Nav.Link>
                                <Nav.Link href="/projects">Projects✨</Nav.Link>
                                <Nav.Link href='https://www.linkedin.com/in/sodiq-azeez-fs' target={'_blank'} className='contactMeLink'>Contact me</Nav.Link>
                            </Nav>

                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>

        </>
    );
}

export default HomeNav;